import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsInlineSkateNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g
        clipPath="url(#sports_inline_skate_normal_xsmall_svg__clip0_138_638)"
        fill=""
      >
        <path d="M2 16a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2.001A1 1 0 012 13z" />
        <path d="M6 16a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2.001A1 1 0 016 13z" />
        <path d="M10 16a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2.002A1 1 0 0110 13z" />
        <path d="M14 16a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2.002A1 1 0 0114 13zM1.08 10.62a2.462 2.462 0 001.89.88h9.49a2.037 2.037 0 00.97-3.83L7.54 4.51V4.5h-.03l-.24-.13.41-2.2A1.409 1.409 0 006.3.5H4.74l-.66 1H1.77L.54 8.61a2.442 2.442 0 00.54 2.01zm11.87-2.07a1.029 1.029 0 01.244 1.644 1.046 1.046 0 01-.734.306h-1.881l1.308-2.521 1.063.571zm-11.43.23L2.61 2.5h2l.67-1H6.3a.366.366 0 01.31.15.376.376 0 01.09.33L6.225 4.5H4v1h3.268l1.132.606L7.16 8.5h1.12l1-1.921 1.72.926-1.553 3H2.97a1.47 1.47 0 01-1.416-1.087 1.507 1.507 0 01-.034-.638z" />
      </g>
      <defs>
        <clipPath id="sports_inline_skate_normal_xsmall_svg__clip0_138_638">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsInlineSkateNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsInlineSkateNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsInlineSkateNormalXsmall;
